import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Reporte, ReporteVacio } from '../../../models'

/**
 * Estado temporal de reportes/evidencias asociados al flujo activo.
 */
export const reportesSlice = createSlice({
  name: 'reportes',
  initialState: ReporteVacio
  ,
  reducers: {
    cargarReportes: (state, action: PayloadAction<Reporte[]>) => ({
      ...state,
      reportes: action.payload,
    }),
  },
})

export const { cargarReportes } = reportesSlice.actions

export default reportesSlice.reducer
